import { render } from "./SearchComponent.vue?vue&type=template&id=c795b33c"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__